import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function TicksLog(props) {
    const { hidden, ticks, getPositions, hiddenSecondaryTicks, ...otherProps } = props;
    if (hidden)
        return null;
    const displayedTicks = hiddenSecondaryTicks
        ? ticks.filter(({ label }) => label !== '')
        : ticks;
    // Primary and secondary Ticks
    return (_jsx(_Fragment, { children: displayedTicks.map(({ label, position }) => {
            const { line, text } = getPositions(position);
            return (_jsx(TickLog, Object.assign({ line: line, text: text }, otherProps, { children: label }), label + position));
        }) }, void 0));
}
export function TickLog(props) {
    const { line: { x1: lineX1 = 0, x2: lineX2 = 0, y1: lineY1 = 0, y2: lineY2 = 0 }, text: { x1: textX1 = 0, y1: textY1 = 0 }, style, children, strokeColor = 'black', strokeHeight = 1, anchor = 'end', secondary = false, } = props;
    return (_jsxs("g", { children: [_jsx("line", { x1: lineX1, x2: secondary && lineX1 !== lineX2 ? lineX2 * strokeHeight : lineX2, y1: lineY1, y2: secondary && lineY1 !== lineY2 ? lineY2 * strokeHeight : lineY2, stroke: strokeColor, strokeWidth: secondary ? 1 : 1.5 }, void 0),
            !secondary && (_jsx("text", Object.assign({ x: textX1, y: textY1, textAnchor: anchor, dominantBaseline: "middle", style: { userSelect: 'none', ...style } }, { children: children }), void 0))] }, void 0));
}
//# sourceMappingURL=TicksLog.js.map